module.exports = __webpack_public_path__ + "img/note.cf402828.png";